import { useSelector } from "react-redux";
import { Placeholder } from "semantic-ui-react";
import LoadingLine from "./LoadingLine";
import CustomLine from "./customLine";

const LoadingBank = ({ commonLoading, children, className, mapIndex = 2 }) => {
  const loadingStatus = useSelector((state) => state.isLoaderStatus);

  const isDarkMode = useSelector((state) => state.isTheme === "dark");

  return commonLoading || loadingStatus
    ? Array.from({ length: mapIndex }, (_, i) => i).map((item) => {
        return (
          <Placeholder
            inverted={isDarkMode}
            className={`${className} h-[71px] rounded-xl !mt-0 mb-[10px] p-[12px] flex items-center justify-between`}
          >
            <div className="flex items-center gap-[20px] h-full">
              <CustomLine className={`w-[45px] h-[45px]`} circle />
              <div className="flex flex-col justify-between h-full">
                <CustomLine className={`h-[17px] w-[110px]`} />
                <CustomLine className={`h-[13px] w-[60px]`} />
              </div>
            </div>
          </Placeholder>
        );
      })
    : children;
};

export default LoadingBank;
